import { render, staticRenderFns } from "./EditIfttt.vue?vue&type=template&id=3296d83b&scoped=true"
import script from "./EditIfttt.vue?vue&type=script&lang=js"
export * from "./EditIfttt.vue?vue&type=script&lang=js"
import style0 from "./EditIfttt.vue?vue&type=style&index=0&id=3296d83b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3296d83b",
  null
  
)

export default component.exports